import React, { memo, useRef } from 'react'
import Draggable from 'components/Draggable/Draggable'
import FilterItemButton from 'components/FilterItemButton/FilterItemButton'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import sx from './styles'

const FiltersSelected = ({
  items = [],
  onDeleteItem,
  onDeleteAllFilters,
}) => {
  const dragRef = useRef(null)

  return (
    items?.length > 0 && (
      <Draggable innerRef={dragRef}>
        <Grid
          item
          xs={12}
          marginTop={1}
          sx={sx.filtercontainer}
        >
          {items.map((item) => (
            <FilterItemButton
              key={item}
              item={item}
              onDeleteItem={onDeleteItem}
            />
          ))}
          {
            items.length > 3 && (
              <Box mr={0.5}>
                <Button
                  variant="outlined"
                  sx={sx.button}
                  onClick={onDeleteAllFilters}
                >
                  <DeleteIcon />
                </Button>
              </Box>
            )
          }
        </Grid>
      </Draggable>
    )
  )
}

export default memo(FiltersSelected)
